import { difference, recordOnce } from '@fandom/tracking-metrics/timing/timings'
export { recordOnce } from '@fandom/tracking-metrics/timing/timings'

const TIMING_SAMPLE_RATE = 1
export const TIMING_FEATURED_VIDEO_INIT = 'featured-video-init'

export function recordAndTrackDifference(
    eventToRecord: string,
    eventToDiff: string,
) {
    const time = recordOnce(eventToRecord, { sampleRate: TIMING_SAMPLE_RATE })

    if (time !== null) {
        difference(eventToDiff, eventToRecord, {
            sampleRate: TIMING_SAMPLE_RATE,
        })
    }
}
